import { useState } from "react";
import { Button, FormCheck, Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

interface props {
    show: boolean;
    onHide: () => void;
    onDelete: (selected: string) => void;
}
export function DeleteCompleted(props: props) {
    const [selected, setSelected] = useState("week");
    return (
        <Modal show={props.show} onHide={props.onHide} centered={true}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Completed Jobs?</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <FormCheck
                    type="radio"
                    label="Keep none (delete all)"
                    name="radioGroup"
                    id="none"
                    checked={selected === "none"}
                    onChange={() => setSelected("none")}
                />
                <FormCheck
                    type="radio"
                    label="Keep jobs from past week"
                    name="radioGroup"
                    id="week"
                    checked={selected === "week"}
                    onChange={() => setSelected("week")}
                />
                <FormCheck
                    type="radio"
                    label="Keep jobs from past month"
                    name="radioGroup"
                    id="month"
                    checked={selected === "month"}
                    onChange={() => setSelected("month")}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={() => props.onDelete(selected)} variant="primary">Delete Jobs</Button>
            </Modal.Footer>
        </Modal>
    );
}
